/* eslint-disable react-hooks/exhaustive-deps */
"use client";
import React, { useEffect } from "react";
import NavbarSubMenuWrapper from "./NavbarSubMenuWrapper";
import { GoArrowRight } from "react-icons/go";
import { usePathname } from "next/navigation";
import { IconType } from "react-icons";
import { servicesByCategory } from "@/data/service.data";
import BookMeetingLink from "../shared/BookMeetingLink";
import { TransitionLink } from "../shared/TransitionLink";
import { useDict } from "@/components/providers/LocaleProvider";

interface ServicesSubMenuProps {
  isOpen: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export interface SubServiceProps {
  title: string;
  services: {
    name: string;
    shortDescription?: string;
    Icon: IconType;
  }[];
}

const ServicesSubMenu = ({
  isOpen,
  onMouseEnter,
  onMouseLeave,
}: ServicesSubMenuProps) => {
  const pathname = usePathname();
  const t = useDict();

  useEffect(() => {
    if (onMouseLeave) {
      onMouseLeave();
    }
  }, [pathname]);

  return (
    <NavbarSubMenuWrapper isOpen={isOpen}>
      <section
        onMouseEnter={() => onMouseEnter && onMouseEnter()}
        onMouseLeave={() => onMouseLeave && onMouseLeave()}
        className=" h-full w-full px-[5%]  py-6  max-w-maxwidth mx-auto grid grid-cols-3 items-center gap-6"
      >
        <SubService
          title={t.nav.servicesPanel.creative}
          services={servicesByCategory.creative.map((s) => {
            const copy = t.navServiceCategoryItems.creative[s.key];
            return {
              name: copy.name,
              shortDescription: copy.shortDescription,
              Icon: s.Icon,
            };
          })}
        />
        <SubService
          title={t.nav.servicesPanel.development}
          services={servicesByCategory.development.map((s) => {
            const copy = t.navServiceCategoryItems.development[s.key];
            return {
              name: copy.name,
              shortDescription: copy.shortDescription,
              Icon: s.Icon,
            };
          })}
        />
        {/* Book a meeting */}
        <section className=" flex-1 flex flex-col h-full  justify-between  ">
          <article className=" space-y-1">
            <p>
              <strong>{t.home.bookAMeeting.cardTitle}</strong>
            </p>
            <p>{t.home.bookAMeeting.cardDescription}</p>
          </article>

          <BookMeetingLink />
        </section>
      </section>
    </NavbarSubMenuWrapper>
  );
};

function SubService({ title, services }: SubServiceProps) {
  const t = useDict();
  return (
    <section className=" flex flex-1 flex-col gap-y-4">
      <p className=" px-4 py-2  rounded-lg   bg-dark-gray border  border-light-border">
        {title}
      </p>
      <div className=" flex flex-col gap-y-4">
        {services.map((service, index) => (
          <div key={index} className=" flex items-center gap-x-4">
            <div className=" size-10 flex justify-center items-center text-base rounded-lg    bg-dark-gray border  border-light-border">
              <service.Icon size={20} />
            </div>
            <div>
              <p>{service.name}</p>
              <p className=" text-sm   text-light-text">
                {service.shortDescription}
              </p>
            </div>
          </div>
        ))}
        <TransitionLink
          href={"/services"}
          className=" w-full active:scale-95 cursor-pointer hover:bg-gray-100 duration-200 gap-2 group bg-white text-black  py-2 rounded-lg flex justify-center items-center"
        >
          {t.nav.exploreMore}
          <GoArrowRight
            size={20}
            className="group-hover:-mr-3 ml-0 duration-200"
          />
        </TransitionLink>
      </div>
    </section>
  );
}

export default ServicesSubMenu;
